import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-494">
      <PriceAlert data-id="element-495" />
      <Hero data-id="element-496" />
      <Testimonial data-id="element-497" />
      <ProblemSolution data-id="element-498" />
      <ValueStack data-id="element-499" />
      <ModuleBreakdown data-id="element-500" />
      <Guarantee data-id="element-501" />
      <PricingSection data-id="element-502" />
      <Footer data-id="element-503" />
      <RecentPurchaseToast data-id="element-504" />
    </div>;
}